import { Checkbox, FieldSet, Label, LabeledControl, Legend, Text } from '@zillow/constellation-10';

import { NEGOTIABLE } from '../../../constants/ListingCriteriaConstants';

import type { ChangeEvent } from 'react';

const radioControlName = NEGOTIABLE;

type MockEventProps = {
  target: {
    name: string;
    value: string | boolean;
  };
  persist?: () => void;
};

type SaveEvent = ChangeEvent<HTMLInputElement> | MockEventProps;

type Props = {
  handleChange: (event: SaveEvent) => void;
  checkedValue?: boolean;
  isDisabled?: boolean;
};

const LCNegotiableFieldSet = ({ handleChange, checkedValue, isDisabled = false }: Props): JSX.Element => {
  return (
    <FieldSet data-testid="LCNegotiableFieldSet" legend={<Legend />} disabled={isDisabled}>
      <LabeledControl
        controlId="negotiable"
        label={
          <Label>
            <Text textStyle="body-bold">Let renters know this is negotiable.</Text>
          </Label>
        }
        control={
          <Checkbox
            name={radioControlName}
            value={checkedValue ? 'false' : 'true'}
            checked={checkedValue === true}
            onChange={handleChange}
          />
        }
      />
    </FieldSet>
  );
};

export default LCNegotiableFieldSet;
